"use client";
import BlogCardComponent from "./BlogCard";
import { cva } from "../../styled-system/css";

const blogGridRecipe = cva({
  base: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    "@media (max-width: 900px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 600px)": {
      gridTemplateColumns: "1fr",
      gridGap: "2rem",
    },
    gridGap: "1rem",
  },
});

function BlogGridComponent() {
  return (
    <div className={blogGridRecipe()}>
      <BlogCardComponent />
      <BlogCardComponent />
      <BlogCardComponent />
      <BlogCardComponent />
      <BlogCardComponent />
    </div>
  );
}

export default BlogGridComponent;
